module.exports = __webpack_public_path__ + "static/media/fleche.910be05a.svg";